import { useEffect, useState } from 'react';

export const browserDetails = {
  chrome: 'Google Chrome',
  edge: 'Microsoft Edge',
  firefox: 'Mozilla Firefox',
  opera: 'Opera',
  safari: 'Safari',
  ie: 'Internet Explorer',
  unknown: 'Unknown'
};

export const useBrowserType = () => {
  const [isChromeBrowser, setIsChromeBrowser] = useState(true);

  const handleChromeBrowser = (browser) => {
    if (
      browser === browserDetails.chrome ||
      browser === browserDetails.firefox ||
      browser === browserDetails.edge
    ) {
      setIsChromeBrowser(true);
    } else {
      setIsChromeBrowser(false);
    }
  };

  const detectBrowser = () => {
    const userAgent = navigator.userAgent;

    if (userAgent.indexOf('Chrome') > -1) {
      if (userAgent.indexOf('Edge') > -1) {
        handleChromeBrowser(browserDetails.edge); // Edge
      } else if (userAgent.indexOf('OPR') > -1) {
        handleChromeBrowser(browserDetails.opera); // Opera
      } else {
        handleChromeBrowser(browserDetails.chrome); // Chrome
      }
    } else if (userAgent.indexOf('Firefox') > -1) {
      handleChromeBrowser(browserDetails.firefox); // Firefox
    } else if (userAgent.indexOf('Safari') > -1) {
      handleChromeBrowser(browserDetails.safari); // Safari
    } else if (
      userAgent.indexOf('MSIE') > -1 ||
      userAgent.indexOf('Trident') > -1
    ) {
      handleChromeBrowser(browserDetails.ie); // Internet Explorer
    } else {
      handleChromeBrowser(browserDetails.unknown); // Unknown browser
    }
  };

  useEffect(() => {
    detectBrowser();
  }, []);

  return { isChromeBrowser };
};
